import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const musicURL = `${BASE_URL}/music`;

//Get all music
export const allMusic=async (query)=>apiCallTemplate("get", `${musicURL}${query}`)

//Get five recent music ADMIN
export const recentMusic=async ()=>apiCallTemplate("get", `${musicURL}/recents`)

//Get five recent music User
export const myRecentMusic=async (username)=>apiCallTemplate("get", `${musicURL}/my-uploads/recents/${username}`)

//Site five most streamed music
export const topStreamMusic=async ()=>apiCallTemplate("get", `${musicURL}/top-streams`)

//User five most streamed music
export const myTopStreamMusic=async ()=>apiCallTemplate("get", `${musicURL}/my-upload/top-streams`)

//Get all artiste's music
export const myMusic=async ()=>apiCallTemplate("get", `${musicURL}/my-uploads`)

//Get single music
export const singleMusic=async (id)=>apiCallTemplate("get", `${musicURL}/${id}`)

//Upload music
export const uploadMusic=async (musicData)=>apiCallTemplate("post", `${musicURL}/upload`, musicData,)

//Music fan page
export const musicFanPage=async (artiste, track)=>apiCallTemplate("get", `${musicURL}/my-track/fans-page/${artiste}/${track}`)

//Update Music
export const updateMusic=async (id, data)=>apiCallTemplate("put", `${musicURL}/${id}`, data)

//Music Cover Image
export const CoverMusic=async (id)=>apiCallTemplate("get", `${musicURL}/cover/imqge/view/${id}`)

//Music Streaming
export const musicStreaming=async (folderName, fileName)=>apiCallTemplate("get", `${musicURL}/stream/${folderName}/${fileName}`)

//Music/Image Download
export const musicOrImageDownload=async (folderName, fileName)=>apiCallTemplate("get", `${musicURL}/download/${folderName}/${fileName}`)

//Delete Music
export const deleteMusic=async (id)=>apiCallTemplate("delete", `${musicURL}/${id}`)

//Mark Music Seen
export const markMusicSeen=async (id, data)=>apiCallTemplate("put", `${musicURL}/status/update/${id}`, data)

//Get User total music
export const getMyTotalMuic=async (userId)=>apiCallTemplate("get", `${musicURL}/get/statistics/${userId}`)

//Get User total earnings
export const getMyTotalEarnings=async (userId)=>apiCallTemplate("get", `${musicURL}/get/total/earnings/${userId}`)

//Get User total Streams
export const getMyTotalStreams=async (userId)=>apiCallTemplate("get", `${musicURL}/get/total/streams/${userId}`)

//Get User total Streams by platforms
export const getMyTotalStreamsByPlatforms=async (userId)=>apiCallTemplate("get", `${musicURL}/get/total/streams/platforms/${userId}`)

//Get User total Streams by platforms
export const getSiteTotalMusic=async ()=>apiCallTemplate("get", `${musicURL}/get/statistics`)

//Get User total Streams by platforms
export const getSiteTotalEarnings=async ()=>apiCallTemplate("get", `${musicURL}/get/total/earnings`)

//Get User total Streams by platforms
export const getSiteTotalStreams=async ()=>apiCallTemplate("get", `${musicURL}/get/total/streams`)

//Get User total Streams by platforms
export const getSiteTotalStreamsByPlatforms=async ()=>apiCallTemplate("get", `${musicURL}/get/total/streams/platforms`)

//Get User total Streams by platforms
export const getSiteHighestMusicUploaders=async ()=>apiCallTemplate("get", `${musicURL}/get/highest/uploaders/details`)